var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.fieldComponent,{tag:"component",attrs:{"item":_vm.basicDataItem},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }